module.exports = __webpack_public_path__ + "static/banner-two-shape11-815c5f9d501ef7b4d95bf85fb009d686.png";